import CoreModel from 'core/models/core';


export default CoreModel.extend({
  urlRoot: MOOD_TEXT_API_URL
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/django-mood/mood/static/js/mood/models/mood_text.js
// module id = 157
// module chunks = 0